export enum APIURL {
  Login = '/member/api/login',
  Logout = '/member/api/logout',
  LoginCheck = '/member/api/login_check',
  LoginUser = '/member/api/login_user',
  EntryCheck = '/member/api/entry_check',
  EntryEdit = '/member/api/entry_edit',
  EntryFinish = '/member/api/entry_finish',
  UserEditConfirm = '/member/api/user_edit_confirm',
  UserEditFinish = '/member/api/user_edit_finish',
  MailEdit = '/member/api/mailaddress_edit',
  MailFinish = '/member/api/mailaddress_finish',
  PasswordEdit = '/member/api/password_edit',
  RemindMail = '/member/api/remind_mail',
  RemindFinish = '/member/api/remind_finish',
  Unregister = '/member/api/user_delete',
  JobRole = '/member/api/job_role',
  UnregisterReason = '/member/api/unregister_reason',
  PreRegisterFinish = '/member/api/pre_register_finish'
}
